import { IResolutionPriceResponse3 } from '../../api/models/AndromeTV.types';

/**
 * Values for stream Resolutions
 * @type {{SD: string, HD: string, FOURK: string}}
 */
export const StreamResolutions = {
  SD: 'SD',
  HD: 'HD',
  FOURK: '4K',
};

export class StreamResolutionUtil {
  static toInt(resolution: string) {
    switch (resolution) {
      case StreamResolutions.SD:
        return 1;
      case StreamResolutions.HD:
        return 2;
      case StreamResolutions.FOURK:
        return 3;
    }
    return 0;
  }

  /**
   * compare two resolutions
   * @param {string} a
   * @param {string} b
   * @returns {number}
   */
  static compare(a: string, b: string): number {
    return StreamResolutionUtil.toInt(a) - StreamResolutionUtil.toInt(b);
  }

  static sortCompare(a: IResolutionPriceResponse3, b: IResolutionPriceResponse3) {
    if (StreamResolutionUtil.toInt(a.resolution) > StreamResolutionUtil.toInt(b.resolution)) {
      return -1;
    } else if (StreamResolutionUtil.toInt(a.resolution) < StreamResolutionUtil.toInt(b.resolution)) {
      return 1;
    } else {
      return 0;
    }
  }

  static max(resolutions: string[]) {
    if (resolutions.length === 0) return undefined;
    return resolutions.sort(StreamResolutionUtil.compare)[resolutions.length - 1];
  }

  static min(resolutions: string[]) {
    if (resolutions.length === 0) return undefined;
    return resolutions.sort(StreamResolutionUtil.compare)[0];
  }
}
